import { render, staticRenderFns } from "./ContactInfo.vue?vue&type=template&id=7d207948&scoped=true&"
import script from "./ContactInfo.vue?vue&type=script&lang=ts&"
export * from "./ContactInfo.vue?vue&type=script&lang=ts&"
import style0 from "./ContactInfo.vue?vue&type=style&index=0&id=7d207948&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d207948",
  null
  
)

component.options.__file = "ContactInfo.vue"
export default component.exports